/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_IntroInputs */

const en_us2_gallery_intro = /** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans people shared, published after the team reviewed them. Opening a plan changes nothing in yours: importing goes through the line-by-line review.`)
};

const pt_br2_gallery_intro = /** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos que pessoas compartilharam, publicados depois de a equipe revisar. Abrir um plano não muda nada no seu: importar passa pela revisão linha a linha.`)
};

const pt_pt2_gallery_intro = /** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos que pessoas compartilharam, publicados depois de a equipe revisar. Abrir um plano não muda nada no seu: importar passa pela revisão linha a linha.`)
};

/** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */
const es_419_gallery_intro = en_us2_gallery_intro;

/** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */
const fr_fr2_gallery_intro = en_us2_gallery_intro;

/** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */
const de_de2_gallery_intro = en_us2_gallery_intro;

/** @type {(inputs: Gallery_IntroInputs) => LocalizedString} */
const it_it2_gallery_intro = en_us2_gallery_intro;

/**
* | output |
* | --- |
* | "Plans people shared, published after the team reviewed them. Opening a plan changes nothing in yours: importing goes through the line-by-line review." |
*
* @param {Gallery_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_intro = /** @type {((inputs?: Gallery_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_intro(inputs)
	if (locale === "es-419") return es_419_gallery_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_intro(inputs)
	if (locale === "de-DE") return de_de2_gallery_intro(inputs)
	if (locale === "it-IT") return it_it2_gallery_intro(inputs)
	return en_us2_gallery_intro(inputs)
});
export { gallery_intro as "gallery.intro" }